import filters from "./extras/filters";
import Vue from "vue";
import Vuex from "vuex";
import vuexStore from "./store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import VueAnalytics from "vue-analytics";
import deviceQueries from "./plugins/device-queries";
// import Pace from 'pace-progress'

Vue.config.productionTip = false;

Vue.use(Vuex);

Vue.use(VueAnalytics, {
  id: "UA-4190908-17"
});

let config = {
  baseURL: "https://news.zindaa.mn/",
  method: "post",
  headers: {
    // "X-Requested-With": "*",
    // "X-API-KEY": "lifestyle",
    "content-type": "application/x-www-form-urlencoded"
  }
};
const _axios = axios.create(config);
Vue.use(VueAxios, _axios);
// Vue.use(resource, {
//   resources,
//   endpoint: '/static/api'
// })

Vue.use(deviceQueries, {
  phone: "max-width: 567px",
  tablet: "min-width: 568px",
  mobile: "max-width: 1024px",
  laptop: "min-width: 1025px",
  desktop: "min-width: 1280px",
  monitor: "min-width: 1448px"
});

Vue.use(BootstrapVue);

const store = new Vuex.Store(vuexStore);

Vue.use(filters);

new Vue({
  router,
  store: store,
  render: h => h(App),
  mounted() {
    // Pace.start()
    // Pace.on('hide', () => {
    //   document.dispatchEvent(new Event('app.rendered'))
    // })
  }
}).$mount("#app");
